let lockCount = 0;

function pageBody() {
  return document.querySelector('.page-body');
}

function applyLock() {
  pageBody()?.style.setProperty('overflow', 'hidden');
}

function applyUnlock() {
  pageBody()?.style.removeProperty('overflow');
}

export function lockScroll() {
  lockCount += 1;
  if (lockCount === 1) applyLock();
}

export function unlockScroll() {
  if (lockCount <= 1) {
    lockCount = 0;
    applyUnlock();
    return;
  }
  lockCount -= 1;
}

/** Drop all locks (route changes / sticky overflow recovery). */
export function resetScrollLock() {
  lockCount = 0;
  applyUnlock();
}
